import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HomeIcon from "./../../assets/images/games-icon/headicon/house.png";
import InplayIcon from "./../../assets/images/games-icon/play3d.png";
import CricketIcon from "./../../assets/images/games-icon/Cricket.png";
import SoccerIcon from "./../../assets/images/games-icon/Soccer.png";
import TennisIcon from "./../../assets/images/games-icon/Tennis.png";
import AviatorIcon from "./../../assets/images/games-icon/Aviator.png";
import EvolutionIcon from "./../../assets/images/games-icon/headicon/table-games-new.svg";
import EzugiIcon from "./../../assets/images/games-icon/headicon/roulette.svg";
import XPGNew from "./../../assets/images/games-icon/headicon/xpg-icon.png";
import VivoNew from "./../../assets/images/games-icon/headicon/vivo-icon.png";
import QtechNew from "./../../assets/images/games-icon/headicon/qtech-icon.png";
import OnetouchNew from "./../../assets/images/games-icon/headicon/onetouch-icon.png";
import ParagmaticplayNew from "./../../assets/images/games-icon/headicon/paragmaticplay-icon.png";
import onlyplayNew from "./../../assets/images/games-icon/headicon/onlyplay-icon.png";
import Sportsbook from "./../../assets/images/games-icon/headicon/sportsbook.png";
import SlotsIconNew from "./../../assets/images/games-icon/headicon/slot-machine.png";
import Kingmaker from "./../../assets/images/games-icon/headicon/kingmaker.png";
import casinoround from "./../../assets/images/games-icon/headicon/spin_bg.png";
import casinogame from "./../../assets/images/games-icon/headicon/turntable.png";
import casinopoint from "./../../assets/images/games-icon/headicon/pointer.png";

const LeftBarSports = () => {
  const navigate = useNavigate();

  const { isAuth } = useSelector((state) => state.auth);

  return (
    <>
      <div className="leftbarSec">
        <ul>
          <li className="games_link">
            {/* <h6>Quick Links</h6> */}
            <ul>
              <li>
                <div
                  onClick={() => {
                    navigate("/home");
                  }}
                >
                  <img src={HomeIcon} alt="Home Icon" />
                  <span>Home</span>
                </div>
              </li>
              <li>
                <div
                  className="inplay"
                  onClick={() => {
                    if (isAuth) {
                      navigate("/spmsports/cricket", {
                        state: { selectedTab: "1" },
                      });
                    } else {
                      navigate("/spmsports/cricket", {
                        state: { selectedTab: "1" },
                      });
                    }
                  }}
                >
                  <img src={InplayIcon} alt="Inplay Icon" className="inplay" />
                  <span>In-play</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/betby");
                  }}
                >
                  <img src={Sportsbook} alt="Casino Icon" />
                  <span>Sportsbook</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/slots");
                  }}
                >
                  <img src={SlotsIconNew} alt="Casino Icon" />
                  <span>Slots</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/kingmaker");
                  }}
                >
                  <img src={Kingmaker} alt="Casino Icon" />
                  <span>Kingmaker</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/supernowa");
                  }}
                  className="no-hover"
                >
                  {/* <img src={CasinoIcon} alt="Casino Icon" /> */}
                  <div className="animate-img">
                    <div className="enter-animate active">
                      <div className="spin-anim">
                        <img src={casinoround} className="img-spinbg" />
                        <img src={casinogame} className="img-turntable" />
                        <img src={casinopoint} className="img-pointer" />
                      </div>
                    </div>
                  </div>
                  <span>Supernowa</span>
                </div>
              </li>
            </ul>
          </li>

          <li className="games_link">
            {/* <h6>Sports</h6> */}
            <ul>
              <li>
                <div
                  onClick={() => {
                    if (isAuth) {
                      navigate("/spmsports/cricket", {
                        state: { selectedTab: "2" },
                      });
                    } else {
                      navigate("/spmsports/cricket", {
                        state: { selectedTab: "2" },
                      });
                    }
                  }}
                >
                  <img src={CricketIcon} alt="Cricket Icon" />
                  <span>Cricket</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    if (isAuth) {
                      navigate("/spmsports/soccer", {
                        state: { selectedTab: "3" },
                      });
                    } else {
                      navigate("/spmsports/soccer", {
                        state: { selectedTab: "3" },
                      });
                    }
                  }}
                >
                  <img src={SoccerIcon} alt="Soccer Icon" />
                  <span>Soccer</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    if (isAuth) {
                      navigate("/spmsports/tennis", {
                        state: { selectedTab: "4" },
                      });
                    } else {
                      navigate("/spmsports/tennis", {
                        state: { selectedTab: "4" },
                      });
                    }
                  }}
                >
                  <img src={TennisIcon} alt=" Icon" />
                  <span>Tennis</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/spribe/aviator");
                  }}
                >
                  <img src={AviatorIcon} alt="Casino Icon" />
                  <span>Aviator</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/evolution");
                  }}
                >
                  <img src={EvolutionIcon} alt="Casino Icon" />
                  <span>Evolution</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/ezugi");
                  }}
                >
                  <img src={EzugiIcon} alt="Casino Icon" />
                  <span>Ezugi</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/xpg");
                  }}
                >
                  <img src={XPGNew} alt="Casino Icon" />
                  <span>XPG</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/vivo");
                  }}
                >
                  <img src={VivoNew} alt="Casino Icon" />
                  <span>Vivo</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/qtech");
                  }}
                >
                  <img src={QtechNew} alt="Casino Icon" />
                  <span>Qtech</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/worldcasino");
                  }}
                >
                  <img src={OnetouchNew} alt="Casino Icon" />
                  <span>OneTouch</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/pragmaticplay");
                  }}
                >
                  <img src={ParagmaticplayNew} alt="Casino Icon" />
                  <span>Pragmaticplay</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/casino/onlyplay");
                  }}
                >
                  <img src={onlyplayNew} alt="Casino Icon" />
                  <span>Onlyplay</span>
                </div>
              </li>
              {/* <li>
                <div
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <img src={PromotionIcon} alt="Casino Icon" />
                  <span>Promotion</span>
                </div>
              </li> */}
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LeftBarSports;
//
